@file:OptIn(InternalResourceApi::class)

package villawonka.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.FontResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/villawonka.composeapp.generated.resources/"

internal val Res.font.NotoSans_Bold: FontResource by lazy {
      FontResource("font:NotoSans_Bold", setOf(
        ResourceItem(setOf(), "${MD}font/NotoSans-Bold.woff2", -1, -1),
      ))
    }

internal val Res.font.NotoSans_Medium: FontResource by lazy {
      FontResource("font:NotoSans_Medium", setOf(
        ResourceItem(setOf(), "${MD}font/NotoSans-Medium.woff2", -1, -1),
      ))
    }

internal val Res.font.NotoSans_Regular: FontResource by lazy {
      FontResource("font:NotoSans_Regular", setOf(
        ResourceItem(setOf(), "${MD}font/NotoSans-Regular.woff2", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainFont0Resources(map: MutableMap<String, FontResource>) {
  map.put("NotoSans_Bold", Res.font.NotoSans_Bold)
  map.put("NotoSans_Medium", Res.font.NotoSans_Medium)
  map.put("NotoSans_Regular", Res.font.NotoSans_Regular)
}
